'use strict';

const kebabize = (str) =>
  str.replace(
    /[A-Z]+(?![a-z])|[A-Z]/g,
    ($, ofs) => (ofs ? '-' : '') + $.toLowerCase()
  );

const decodeBase64 = (str) => window.atob(str);

export { kebabize, decodeBase64 };
